// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Proxima Nova:300,300i,400,400i,500,500i,700,700i);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Titillium+Web:ital,wght@0,200;0,300;0,400;0,600;0,700;0,900;1,200;1,300;1,400;1,600;1,700&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://use.typekit.net/ija5zmr.css);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.titilliumweb_font {
  font-family: "Titillium Web", sans-serif !important;
}

.text-gray4 {
  color: #707070 !important;
}

.text-gray3 {
  color: #E5E5E5 !important;
}

.border-theme {
  border-color: #ced4da !important;
}

.text-theme {
  color: #36A1F5 !important;
}

.text-blue {
  color: #231c86 !important;
}

.theme-info {
  color: #00C2FF !important;
}

.bg-theme {
  background: #36A1F5 !important;
}

.bg-darkblue {
  background: #212B65 !important;
}

.theme-red {
  color: #ff0000 !important;
}

.theme-purple {
  color: #A300FF !important;
}

.theme-darkblue {
  color: #212B64 !important;
}

.border-darkblue {
  border-color: #212B65 !important;
}

/*----------------------------------------------
    Buttons
-----------------------------------------------*/
.btn-white {
  font-weight: 400;
  color: #000000;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  background-color: #ffffff;
  border: 1px solid #ffffff;
  padding: 0.5rem 0.75rem;
  font-size: 14px;
  line-height: 1.5;
  border-radius: 0.2rem;
  text-transform: uppercase;
  transition: all 0.5s;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}
.btn-white:hover, .btn-white:active, .btn-white:focus, .btn-white:not(:disabled):not(.disabled):active:focus, .btn-white:not(:disabled):not(.disabled).active:focus, .btn-white:not(:disabled):not(.disabled):active {
  color: #000000;
  background: #f1f3f5;
  border: 1px solid #f1f3f5;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}

.btn-white-outline {
  font-weight: 400;
  color: #707070;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  background-color: transparent;
  border: 1px solid #ced4da;
  padding: 0.5rem 0.75rem;
  font-size: 14px;
  line-height: 1.5;
  border-radius: 0.2rem;
  text-transform: uppercase;
  transition: all 0.5s;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}
.btn-white-outline:hover, .btn-white-outline:active, .btn-white-outline:focus, .btn-white-outline:not(:disabled):not(.disabled):active:focus, .btn-white-outline:not(:disabled):not(.disabled).active:focus, .btn-white-outline:not(:disabled):not(.disabled):active {
  color: #707070;
  background: #f1f3f5;
  border: 1px solid #ced4da;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}

.btn-black {
  font-weight: 400;
  color: #ffffff;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  background-color: #000000;
  border: 1px solid #000000;
  padding: 0.5rem 0.75rem;
  font-size: 14px;
  line-height: 1.5;
  border-radius: 0.2rem;
  text-transform: uppercase;
  transition: all 0.5s;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}
.btn-black:hover, .btn-black:active, .btn-black:focus, .btn-black:not(:disabled):not(.disabled):active:focus, .btn-black:not(:disabled):not(.disabled).active:focus, .btn-black:not(:disabled):not(.disabled):active {
  color: #ffffff;
  background: #212529;
  border: 1px solid #212529;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}

.btn-green {
  font-weight: 400;
  color: #ffffff;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  background-color: #00C596;
  border: 1px solid #00C596;
  padding: 0.5rem 0.75rem;
  font-size: 14px;
  line-height: 1.5;
  border-radius: 0.2rem;
  text-transform: uppercase;
  transition: all 0.5s;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}
.btn-green:hover, .btn-green:active, .btn-green:focus, .btn-green:not(:disabled):not(.disabled):active:focus, .btn-green:not(:disabled):not(.disabled).active:focus, .btn-green:not(:disabled):not(.disabled):active {
  color: #ffffff;
  background-color: #00a780;
  border: 1px solid #00a780;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}

.btn-lightgreen {
  font-weight: 400;
  color: #00C596;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  background-color: hsla(166, 100%, 39%, 0.11);
  border: 1px solid #00C596;
  padding: 0.5rem 0.75rem;
  font-size: 14px;
  line-height: 1.5;
  border-radius: 0.2rem;
  text-transform: uppercase;
  transition: all 0.5s;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}
.btn-lightgreen:hover, .btn-lightgreen:active, .btn-lightgreen:focus, .btn-lightgreen:not(:disabled):not(.disabled):active:focus, .btn-lightgreen:not(:disabled):not(.disabled).active:focus, .btn-lightgreen:not(:disabled):not(.disabled):active {
  color: #00C596;
  background-color: hsla(166, 100%, 39%, 0.4);
  border: 1px solid #009b77;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}

.btn-darkblue {
  font-weight: 400;
  color: #ffffff;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  background: #202B63;
  border: 1px solid #3A4789;
  padding: 0.5rem 0.75rem;
  font-size: 14px;
  line-height: 1.5;
  border-radius: 0.2rem;
  text-transform: uppercase;
  transition: all 0.5s;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}
.btn-darkblue:hover, .btn-darkblue:active, .btn-darkblue:focus, .btn-darkblue:not(:disabled):not(.disabled):active:focus, .btn-darkblue:not(:disabled):not(.disabled).active:focus, .btn-darkblue:not(:disabled):not(.disabled):active {
  color: #ffffff;
  background: #1c2658;
  border: 1px solid #303b74;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}

.btn-darkblue-outline {
  font-weight: 400;
  color: #202B63;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  background: #ffffff;
  border: 1px solid #3A4789;
  padding: 0.5rem 0.75rem;
  font-size: 14px;
  line-height: 1.5;
  border-radius: 0.2rem;
  text-transform: uppercase;
  transition: all 0.5s;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}
.btn-darkblue-outline:hover, .btn-darkblue-outline:active, .btn-darkblue-outline:focus, .btn-darkblue-outline:not(:disabled):not(.disabled):active:focus, .btn-darkblue-outline:not(:disabled):not(.disabled).active:focus, .btn-darkblue-outline:not(:disabled):not(.disabled):active {
  color: #ffffff;
  background: #202B63;
  border: 1px solid #3A4789;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}

.btn-blue {
  font-weight: 400;
  color: #ffffff;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  background-color: #077EE6;
  border: 1px solid #077EE6;
  padding: 0.5rem 0.75rem;
  font-size: 14px;
  line-height: 1.5;
  border-radius: 0.2rem;
  text-transform: uppercase;
  transition: all 0.5s;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}
.btn-blue:hover, .btn-blue:active, .btn-blue:focus, .btn-blue:not(:disabled):not(.disabled):active:focus, .btn-blue:not(:disabled):not(.disabled).active:focus, .btn-blue:not(:disabled):not(.disabled):active {
  color: #ffffff;
  background-color: #0172d4;
  border: 1px solid #0172d4;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}

.btn-blue-outline {
  font-weight: 400;
  color: #077EE6;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  background-color: #ffffff;
  border: 1px solid #077EE6;
  padding: 0.5rem 0.75rem;
  font-size: 14px;
  line-height: 1.5;
  border-radius: 0.2rem;
  text-transform: uppercase;
  transition: all 0.5s;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}
.btn-blue-outline:hover, .btn-blue-outline:active, .btn-blue-outline:focus, .btn-blue-outline:not(:disabled):not(.disabled):active:focus, .btn-blue-outline:not(:disabled):not(.disabled).active:focus, .btn-blue-outline:not(:disabled):not(.disabled):active {
  color: #ffffff;
  background-color: #077EE6;
  border: 1px solid #077EE6;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}

.btn-lightblue {
  font-weight: 400;
  color: #ffffff;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  background-color: #36A1F5;
  border: 1px solid #36A1F5;
  padding: 0.5rem 0.75rem;
  font-size: 14px;
  line-height: 1.5;
  border-radius: 0.2rem;
  text-transform: uppercase;
  transition: all 0.5s;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}
.btn-lightblue:hover, .btn-lightblue:active, .btn-lightblue:focus, .btn-lightblue:not(:disabled):not(.disabled):active:focus, .btn-lightblue:not(:disabled):not(.disabled).active:focus, .btn-lightblue:not(:disabled):not(.disabled):active {
  color: #ffffff;
  background-color: #2aa0fa;
  border: 1px solid #2aa0fa;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}

.btn-lightblue-outline {
  font-weight: 400;
  color: #36A1F5;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  background-color: #F2F9FF;
  border: 1px solid #36A1F5;
  padding: 0.5rem 0.75rem;
  font-size: 14px;
  line-height: 1.5;
  border-radius: 0.2rem;
  text-transform: uppercase;
  transition: all 0.5s;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}
.btn-lightblue-outline:hover, .btn-lightblue-outline:active, .btn-lightblue-outline:focus, .btn-lightblue-outline:not(:disabled):not(.disabled):active:focus, .btn-lightblue-outline:not(:disabled):not(.disabled).active:focus, .btn-lightblue-outline:not(:disabled):not(.disabled):active {
  color: #ffffff;
  background-color: #36A1F5;
  border: 1px solid #36A1F5;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}

.btn-lightred {
  font-weight: 400;
  color: #CB3F3F;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  background-color: #FFEFEF;
  border: 1px solid #FF004E;
  padding: 0.5rem 0.75rem;
  font-size: 14px;
  line-height: 1.5;
  border-radius: 0.2rem;
  text-transform: uppercase;
  transition: all 0.5s;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}
.btn-lightred:hover, .btn-lightred:active, .btn-lightred:focus, .btn-lightred:not(:disabled):not(.disabled):active:focus, .btn-lightred:not(:disabled):not(.disabled).active:focus, .btn-lightred:not(:disabled):not(.disabled):active {
  color: #CB3F3F;
  background-color: #fda3a3;
  border: 1px solid #FF004E;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}

.btn-lightOrange {
  font-weight: 400;
  color: #feb019;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  background-color: #f8efde;
  border: 1px solid #feb019;
  padding: 0.5rem 0.75rem;
  font-size: 14px;
  line-height: 1.5;
  border-radius: 0.2rem;
  text-transform: uppercase;
  transition: all 0.5s;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}
.btn-lightOrange:hover, .btn-lightOrange:active, .btn-lightOrange:focus, .btn-lightOrange:not(:disabled):not(.disabled):active:focus, .btn-lightOrange:not(:disabled):not(.disabled).active:focus, .btn-lightOrange:not(:disabled):not(.disabled):active {
  color: #feb019;
  background-color: #fce9c5;
  border: 1px solid #feb019;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}

.complexity-nav {
  position: relative;
  background: #F39C37;
}
.complexity-nav .header-top {
  position: relative;
  box-shadow: none;
  z-index: 2;
}
.complexity-nav .header-top .navbar-nav {
  align-items: center;
}
.complexity-nav .header-top .navbar-nav .nav-link {
  color: #ffffff;
}
.complexity-nav .header-top .navbar-nav .profile-img {
  background: rgba(255, 255, 255, 0.1647058824);
  border: 1px solid #ffc27b;
  border-radius: 21px;
}
.complexity-nav .header-top .navbar-nav .profile-img img {
  width: 35px;
  height: 35px;
}
.complexity-nav .header-top .navbar-nav .profile-img .text .profile-name {
  font-size: 14px;
  line-height: 6px;
}
.complexity-nav .header-top .search .search-bar {
  color: #ffffff;
  background: rgba(226, 64, 86, 0.4941176471);
  box-shadow: none;
}
.complexity-nav .header-top .student-notification i {
  font-size: 1.5rem;
}
.complexity-nav .header-bottom {
  position: relative;
  z-index: 1;
}
.complexity-nav .header-bottom .title {
  color: #ffffff;
}
.complexity-nav .header-bottom .subtitle {
  color: #ffffff;
}
.complexity-nav .header-bottom .card {
  border-radius: 10px;
  background-color: rgba(255, 255, 255, 0.5019607843);
  border: 1px solid #FBE1C3;
}
.complexity-nav .header-bottom .card img {
  margin-top: -3rem;
  margin-bottom: 10px;
}
.complexity-nav .header-bottom .datePicker .calendar {
  color: #ffffff;
  position: absolute;
  left: 15px;
  top: 0;
  font-size: 18px;
  background: rgba(255, 255, 255, 0.2274509804);
  padding: 10px;
  border-radius: 4px;
}
.complexity-nav .header-bottom .datePicker .form-control {
  padding-left: 40px;
  border: 1px solid #FBE1C3;
  background-color: rgba(255, 255, 255, 0.5019607843);
  color: #ffffff;
}
.complexity-nav .header-bottom .datePicker .form-control::placeholder {
  color: #ffffff;
}
.complexity-nav .header-bottom .datePicker .rdtPicker {
  right: 0;
}

.complexity-analysis .filter button {
  padding: 0.45rem 1rem;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1019607843);
}
.complexity-analysis .exam-wise .card-header {
  background: #EEEEEE;
}
.complexity-analysis .exam-wise .card-header h6.title {
  color: rgba(51, 51, 51, 0.4117647059);
}
.complexity-analysis .exam-wise .card-body .card-group .card .react-bootstrap-table,
.complexity-analysis .exam-wise .card-body .card-group .card .table {
  border: none;
  border-radius: 0;
}
.complexity-analysis .exam-wise .card-body .card-group .card .react-bootstrap-table thead,
.complexity-analysis .exam-wise .card-body .card-group .card .table thead {
  background: #EEEEEE;
}
.complexity-analysis .exam-wise .card-body .card-group .card .react-bootstrap-table thead th,
.complexity-analysis .exam-wise .card-body .card-group .card .table thead th {
  font-size: 13px;
  padding: 1rem 0.35rem;
  font-weight: 400;
  color: #707070;
}
.complexity-analysis .exam-wise .card-body .card-group .card .react-bootstrap-table tbody tr td,
.complexity-analysis .exam-wise .card-body .card-group .card .table tbody tr td {
  font-size: 13px;
  padding: 0.95rem 0.35rem;
}
.complexity-analysis .exam-wise .card-body .card-group .card .react-bootstrap-table tbody tr td:nth-child(2),
.complexity-analysis .exam-wise .card-body .card-group .card .table tbody tr td:nth-child(2) {
  color: #077EE6;
}
.complexity-analysis .exam-wise .card-body .card-group .card .react-bootstrap-table tbody tr td:nth-child(3),
.complexity-analysis .exam-wise .card-body .card-group .card .table tbody tr td:nth-child(3) {
  color: #00C596;
}
.complexity-analysis .exam-wise .card-body .card-group .card .react-bootstrap-table tbody tr td:nth-child(4),
.complexity-analysis .exam-wise .card-body .card-group .card .table tbody tr td:nth-child(4) {
  color: #FEAF55;
}
.complexity-analysis .exam-wise .card-body .card-group .card .react-bootstrap-table tbody tr td:last-child,
.complexity-analysis .exam-wise .card-body .card-group .card .table tbody tr td:last-child {
  color: #F05D70;
}
.complexity-analysis .complexity-subjects {
  position: relative;
  border-radius: 6px;
}
.complexity-analysis .complexity-subjects .table thead th {
  border: 1px solid #dee2e6;
}
.complexity-analysis .complexity-subjects .table thead th .accurency {
  background: rgba(216, 225, 233, 0.5019607843);
  border-radius: 5px;
  padding: 0.45rem 0.75rem;
}
.complexity-analysis .complexity-subjects .table thead th .accurency p {
  font-weight: 400;
}
.complexity-analysis .complexity-question {
  position: relative;
}
.complexity-analysis .complexity-question .react-bootstrap-table,
.complexity-analysis .complexity-question .table {
  border: none !important;
}
.complexity-analysis .complexity-question .react-bootstrap-table thead,
.complexity-analysis .complexity-question .table thead {
  background-color: #ffffff;
}
.complexity-analysis .complexity-question .react-bootstrap-table th,
.complexity-analysis .complexity-question .react-bootstrap-table td,
.complexity-analysis .complexity-question .table th,
.complexity-analysis .complexity-question .table td {
  padding: 0.95rem 0.55rem;
  outline: none;
}
.complexity-analysis .complexity-question .table thead {
  border-top: 1px solid #dee2e6;
  border-bottom: 1px solid #dee2e6;
}
.complexity-analysis .complexity-question .table thead th {
  border-right: 1px solid #dee2e6;
}
.complexity-analysis .complexity-question .table thead th:nth-child(2n) {
  border-right: 1px solid #dee2e6;
}
.complexity-analysis .complexity-question .table thead th:last-child, .complexity-analysis .complexity-question .table thead th:nth-child(2), .complexity-analysis .complexity-question .table thead th:nth-child(4), .complexity-analysis .complexity-question .table thead th:nth-child(6), .complexity-analysis .complexity-question .table thead th:nth-child(8) {
  border-right: 0;
}
.complexity-analysis .complexity-question .table tbody td {
  border-right: 1px solid #dee2e6;
}
.complexity-analysis .complexity-question .table tbody td:last-child, .complexity-analysis .complexity-question .table tbody td:nth-child(2), .complexity-analysis .complexity-question .table tbody td:nth-child(4), .complexity-analysis .complexity-question .table tbody td:nth-child(6), .complexity-analysis .complexity-question .table tbody td:nth-child(8) {
  font-weight: 600 !important;
  border-right: 0;
}
.complexity-analysis .complexity-question .table tbody td:nth-child(3), .complexity-analysis .complexity-question .table tbody td:nth-child(5), .complexity-analysis .complexity-question .table tbody td:nth-child(7), .complexity-analysis .complexity-question .table tbody td:nth-child(9) {
  font-weight: 400 !important;
  color: #077EE6;
}`, "",{"version":3,"sources":["webpack://./src/_config.scss","webpack://./src/neetjee_guru/components/analysis/complexity_analysis/_complexity.scss"],"names":[],"mappings":"AAkCA;EACI,mDAAA;AC9BJ;;ADiCA;EACI,yBAAA;AC9BJ;;ADiCA;EACI,yBAAA;AC9BJ;;ADiCA;EACI,gCAAA;AC9BJ;;ADiCA;EACI,yBAAA;AC9BJ;;ADiCA;EACI,yBAAA;AC9BJ;;ADiCA;EACI,yBAAA;AC9BJ;;ADiCA;EACI,8BAAA;AC9BJ;;ADiCA;EACI,8BAAA;AC9BJ;;ADiCA;EACI,yBAAA;AC9BJ;;ADiCA;EACI,yBAAA;AC9BJ;;ADiCA;EACI,yBAAA;AC9BJ;;ADiCA;EACI,gCAAA;AC9BJ;;ADkCA;;gDAAA;AAIA;EACI,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,yBAAA;EACA,yBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,oBAAA;EACA,iDAAA;AChCJ;ADkCI;EAMI,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,iDAAA;ACrCR;;ADyCA;EACI,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,6BAAA;EACA,yBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,oBAAA;EACA,iDAAA;ACtCJ;ADwCI;EAMI,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,iDAAA;AC3CR;;AD+CA;EACI,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,yBAAA;EACA,yBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,oBAAA;EACA,iDAAA;AC5CJ;AD8CI;EAMI,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,iDAAA;ACjDR;;ADqDA;EACI,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,yBAAA;EACA,yBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,oBAAA;EACA,iDAAA;AClDJ;ADoDI;EAMI,cAAA;EACA,yBAAA;EACA,yBAAA;EACA,iDAAA;ACvDR;;AD2DA;EACI,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,4CAAA;EACA,yBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,oBAAA;EACA,iDAAA;ACxDJ;AD0DI;EAMI,cAAA;EACA,2CAAA;EACA,yBAAA;EACA,iDAAA;AC7DR;;ADiEA;EACI,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,mBAAA;EACA,yBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,oBAAA;EACA,iDAAA;AC9DJ;ADgEI;EAMI,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,iDAAA;ACnER;;ADuEA;EACI,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,mBAAA;EACA,yBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,oBAAA;EACA,iDAAA;ACpEJ;ADsEI;EAMI,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,iDAAA;ACzER;;AD6EA;EACI,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,yBAAA;EACA,yBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,oBAAA;EACA,iDAAA;AC1EJ;AD4EI;EAMI,cAAA;EACA,yBAAA;EACA,yBAAA;EACA,iDAAA;AC/ER;;ADoFA;EACI,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,yBAAA;EACA,yBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,oBAAA;EACA,iDAAA;ACjFJ;ADmFI;EAMI,cAAA;EACA,yBAAA;EACA,yBAAA;EACA,iDAAA;ACtFR;;AD0FA;EACI,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,yBAAA;EACA,yBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,oBAAA;EACA,iDAAA;ACvFJ;ADyFI;EAMI,cAAA;EACA,yBAAA;EACA,yBAAA;EACA,iDAAA;AC5FR;;AD+FA;EACI,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,yBAAA;EACA,yBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,oBAAA;EACA,iDAAA;AC5FJ;AD8FI;EAMI,cAAA;EACA,yBAAA;EACA,yBAAA;EACA,iDAAA;ACjGR;;ADqGA;EACI,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,yBAAA;EACA,yBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,oBAAA;EACA,iDAAA;AClGJ;ADqGI;EAMI,cAAA;EACA,yBAAA;EACA,yBAAA;EACA,iDAAA;ACxGR;;AD4GA;EACI,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,yBAAA;EACA,yBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,oBAAA;EACA,iDAAA;ACzGJ;AD2GI;EAMI,cAAA;EACA,yBAAA;EACA,yBAAA;EACA,iDAAA;AC9GR;;AA9WA;EACI,kBAAA;EACA,mBAAA;AAiXJ;AA/WI;EACI,kBAAA;EACA,gBAAA;EACA,UAAA;AAiXR;AA/WQ;EACI,mBAAA;AAiXZ;AA/WY;EACI,cAAA;AAiXhB;AA9WY;EACI,6CAAA;EACA,yBAAA;EACA,mBAAA;AAgXhB;AA9WgB;EACI,WAAA;EACA,YAAA;AAgXpB;AA5WoB;EACI,eAAA;EACA,gBAAA;AA8WxB;AAxWQ;EACI,cAAA;EACA,2CAAA;EACA,gBAAA;AA0WZ;AAvWQ;EACI,iBAAA;AAyWZ;AArWI;EACI,kBAAA;EACA,UAAA;AAuWR;AArWQ;EACI,cAAA;AAuWZ;AApWQ;EACI,cAAA;AAsWZ;AAnWQ;EACI,mBAAA;EACA,mDAAA;EACA,yBAAA;AAqWZ;AAnWY;EACI,iBAAA;EACA,mBAAA;AAqWhB;AAhWY;EACI,cAAA;EACA,kBAAA;EACA,UAAA;EACA,MAAA;EACA,eAAA;EACA,6CAAA;EACA,aAAA;EACA,kBAAA;AAkWhB;AA/VY;EACI,kBAAA;EACA,yBAAA;EACA,mDAAA;EACA,cAAA;AAiWhB;AA/VgB;EACI,cAAA;AAiWpB;AA7VY;EACI,QAAA;AA+VhB;;AAvVQ;EACI,qBAAA;EACA,oDAAA;AA0VZ;AArVQ;EACI,mBAAA;AAuVZ;AArVY;EACI,qCAAA;AAuVhB;AAjVY;;EAEI,YAAA;EACA,gBAAA;AAmVhB;AAjVgB;;EACI,mBAAA;AAoVpB;AAlVoB;;EACI,eAAA;EACA,qBAAA;EACA,gBAAA;EACA,cAAA;AAqVxB;AAjVgB;;EACI,eAAA;EACA,wBAAA;AAoVpB;AAlVoB;;EACI,cAAA;AAqVxB;AAlVoB;;EACI,cAAA;AAqVxB;AAlVoB;;EACI,cAAA;AAqVxB;AAlVoB;;EACI,cAAA;AAqVxB;AA9UI;EACI,kBAAA;EACA,kBAAA;AAgVR;AA7UY;EACI,yBAAA;AA+UhB;AA7UgB;EACI,6CAAA;EACA,kBAAA;EACA,wBAAA;AA+UpB;AA7UoB;EACI,gBAAA;AA+UxB;AAxUI;EACI,kBAAA;AA0UR;AAxUQ;;EAEI,uBAAA;AA0UZ;AAxUY;;EACI,yBAAA;AA2UhB;AAxUY;;;;EAEI,wBAAA;EACA,aAAA;AA4UhB;AAvUY;EACI,6BAAA;EACA,gCAAA;AAyUhB;AAvUgB;EACI,+BAAA;AAyUpB;AAvUoB;EACI,+BAAA;AAyUxB;AAtUoB;EAKI,eAAA;AAoUxB;AA9TgB;EACI,+BAAA;AAgUpB;AA9ToB;EAKI,2BAAA;EACA,eAAA;AA4TxB;AAzToB;EAII,2BAAA;EACA,cAAA;AAwTxB","sourcesContent":["// @import url('https://fonts.googleapis.com/css?family=Ubuntu:300,300i,400,400i,500,500i,700,700i&display=swap');\n@import url('https://fonts.googleapis.com/css?family=Proxima%20Nova:300,300i,400,400i,500,500i,700,700i');\n@import url('https://fonts.googleapis.com/css2?family=Titillium+Web:ital,wght@0,200;0,300;0,400;0,600;0,700;0,900;1,200;1,300;1,400;1,600;1,700&display=swap');\n@import url(\"https://use.typekit.net/ija5zmr.css\");\n\n$theme1: #36A1F5;\n$theme2: #1B2430;\n$white: #ffffff;\n$gray: #ced4da;\n$gray-2: #F2F2F2;\n$gray-3: #E5E5E5;\n$gray-4: #707070;\n$gray-5: #969DAA;\n$green: #01b306;\n$blue: #231c86;\n// #e7e9ea\n$one: #52B8FA;\n$two: #FAEF52;\n$three: #FABC52;\n$four: #AC52FA;\n$five: #FA52C2;\n$six: #FA5252;\n\n// $font-family: 'Ubuntu', sans-serif !important;\n$font-family: 'proxima-nova',\nsans-serif !important;\n\n@mixin fonts ($fontWeight, $fontSize, $lineHeight) {\n    font-family: $font-family;\n    font-size: $fontSize !important;\n    font-weight: $fontWeight !important;\n    line-height: $lineHeight;\n}\n\n.titilliumweb_font {\n    font-family: 'Titillium Web', sans-serif !important;\n}\n\n.text-gray4 {\n    color: $gray-4 !important;\n}\n\n.text-gray3 {\n    color: $gray-3 !important;\n}\n\n.border-theme {\n    border-color: $gray !important;\n}\n\n.text-theme {\n    color: $theme1 !important;\n}\n\n.text-blue {\n    color: $blue !important;\n}\n\n.theme-info {\n    color: #00C2FF !important;\n}\n\n.bg-theme {\n    background: $theme1 !important;\n}\n\n.bg-darkblue {\n    background: #212B65 !important;\n}\n\n.theme-red {\n    color: #ff0000 !important;\n}\n\n.theme-purple {\n    color: #A300FF !important;\n}\n\n.theme-darkblue {\n    color: #212B64 !important;\n}\n\n.border-darkblue {\n    border-color: #212B65 !important;\n}\n\n\n/*----------------------------------------------\n    Buttons\n-----------------------------------------------*/\n\n.btn-white {\n    font-weight: 400;\n    color: #000000;\n    text-align: center;\n    vertical-align: middle;\n    cursor: pointer;\n    user-select: none;\n    background-color: #ffffff;\n    border: 1px solid #ffffff;\n    padding: 0.5rem 0.75rem;\n    font-size: 14px;\n    line-height: 1.5;\n    border-radius: 0.2rem;\n    text-transform: uppercase;\n    transition: all 0.5s;\n    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n\n    &:hover,\n    &:active,\n    &:focus,\n    &:not(:disabled):not(.disabled):active:focus,\n    &:not(:disabled):not(.disabled).active:focus,\n    &:not(:disabled):not(.disabled):active {\n        color: #000000;\n        background: #f1f3f5;\n        border: 1px solid #f1f3f5;\n        box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n    }\n}\n\n.btn-white-outline {\n    font-weight: 400;\n    color: #707070;\n    text-align: center;\n    vertical-align: middle;\n    cursor: pointer;\n    user-select: none;\n    background-color: transparent;\n    border: 1px solid #ced4da;\n    padding: 0.5rem 0.75rem;\n    font-size: 14px;\n    line-height: 1.5;\n    border-radius: 0.2rem;\n    text-transform: uppercase;\n    transition: all 0.5s;\n    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n\n    &:hover,\n    &:active,\n    &:focus,\n    &:not(:disabled):not(.disabled):active:focus,\n    &:not(:disabled):not(.disabled).active:focus,\n    &:not(:disabled):not(.disabled):active {\n        color: #707070;\n        background: #f1f3f5;\n        border: 1px solid #ced4da;\n        box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n    }\n}\n\n.btn-black {\n    font-weight: 400;\n    color: #ffffff;\n    text-align: center;\n    vertical-align: middle;\n    cursor: pointer;\n    user-select: none;\n    background-color: #000000;\n    border: 1px solid #000000;\n    padding: 0.5rem 0.75rem;\n    font-size: 14px;\n    line-height: 1.5;\n    border-radius: 0.2rem;\n    text-transform: uppercase;\n    transition: all 0.5s;\n    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n\n    &:hover,\n    &:active,\n    &:focus,\n    &:not(:disabled):not(.disabled):active:focus,\n    &:not(:disabled):not(.disabled).active:focus,\n    &:not(:disabled):not(.disabled):active {\n        color: #ffffff;\n        background: #212529;\n        border: 1px solid #212529;\n        box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n    }\n}\n\n.btn-green {\n    font-weight: 400;\n    color: #ffffff;\n    text-align: center;\n    vertical-align: middle;\n    cursor: pointer;\n    user-select: none;\n    background-color: #00C596;\n    border: 1px solid #00C596;\n    padding: 0.5rem 0.75rem;\n    font-size: 14px;\n    line-height: 1.5;\n    border-radius: 0.2rem;\n    text-transform: uppercase;\n    transition: all 0.5s;\n    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n\n    &:hover,\n    &:active,\n    &:focus,\n    &:not(:disabled):not(.disabled):active:focus,\n    &:not(:disabled):not(.disabled).active:focus,\n    &:not(:disabled):not(.disabled):active {\n        color: #ffffff;\n        background-color: #00a780;\n        border: 1px solid #00a780;\n        box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n    }\n}\n\n.btn-lightgreen {\n    font-weight: 400;\n    color: #00C596;\n    text-align: center;\n    vertical-align: middle;\n    cursor: pointer;\n    user-select: none;\n    background-color: hsla(166, 100%, 39%, 0.11);\n    border: 1px solid #00C596;\n    padding: 0.5rem 0.75rem;\n    font-size: 14px;\n    line-height: 1.5;\n    border-radius: 0.2rem;\n    text-transform: uppercase;\n    transition: all 0.5s;\n    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n\n    &:hover,\n    &:active,\n    &:focus,\n    &:not(:disabled):not(.disabled):active:focus,\n    &:not(:disabled):not(.disabled).active:focus,\n    &:not(:disabled):not(.disabled):active {\n        color: #00C596;\n        background-color: hsla(166, 100%, 39%, 0.4);\n        border: 1px solid #009b77;\n        box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n    }\n}\n\n.btn-darkblue {\n    font-weight: 400;\n    color: #ffffff;\n    text-align: center;\n    vertical-align: middle;\n    cursor: pointer;\n    user-select: none;\n    background: #202B63;\n    border: 1px solid #3A4789;\n    padding: 0.5rem 0.75rem;\n    font-size: 14px;\n    line-height: 1.5;\n    border-radius: 0.2rem;\n    text-transform: uppercase;\n    transition: all 0.5s;\n    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n\n    &:hover,\n    &:active,\n    &:focus,\n    &:not(:disabled):not(.disabled):active:focus,\n    &:not(:disabled):not(.disabled).active:focus,\n    &:not(:disabled):not(.disabled):active {\n        color: #ffffff;\n        background: #1c2658;\n        border: 1px solid #303b74;\n        box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n    }\n}\n\n.btn-darkblue-outline {\n    font-weight: 400;\n    color: #202B63;\n    text-align: center;\n    vertical-align: middle;\n    cursor: pointer;\n    user-select: none;\n    background: #ffffff;\n    border: 1px solid #3A4789;\n    padding: 0.5rem 0.75rem;\n    font-size: 14px;\n    line-height: 1.5;\n    border-radius: 0.2rem;\n    text-transform: uppercase;\n    transition: all 0.5s;\n    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n\n    &:hover,\n    &:active,\n    &:focus,\n    &:not(:disabled):not(.disabled):active:focus,\n    &:not(:disabled):not(.disabled).active:focus,\n    &:not(:disabled):not(.disabled):active {\n        color: #ffffff;\n        background: #202B63;\n        border: 1px solid #3A4789;\n        box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n    }\n}\n\n.btn-blue {\n    font-weight: 400;\n    color: #ffffff;\n    text-align: center;\n    vertical-align: middle;\n    cursor: pointer;\n    user-select: none;\n    background-color: #077EE6;\n    border: 1px solid #077EE6;\n    padding: 0.5rem 0.75rem;\n    font-size: 14px;\n    line-height: 1.5;\n    border-radius: 0.2rem;\n    text-transform: uppercase;\n    transition: all 0.5s;\n    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n\n    &:hover,\n    &:active,\n    &:focus,\n    &:not(:disabled):not(.disabled):active:focus,\n    &:not(:disabled):not(.disabled).active:focus,\n    &:not(:disabled):not(.disabled):active {\n        color: #ffffff;\n        background-color: #0172d4;\n        border: 1px solid #0172d4;\n        box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n    }\n}\n\n\n.btn-blue-outline {\n    font-weight: 400;\n    color: #077EE6;\n    text-align: center;\n    vertical-align: middle;\n    cursor: pointer;\n    user-select: none;\n    background-color: #ffffff;\n    border: 1px solid #077EE6;\n    padding: 0.5rem 0.75rem;\n    font-size: 14px;\n    line-height: 1.5;\n    border-radius: 0.2rem;\n    text-transform: uppercase;\n    transition: all 0.5s;\n    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n\n    &:hover,\n    &:active,\n    &:focus,\n    &:not(:disabled):not(.disabled):active:focus,\n    &:not(:disabled):not(.disabled).active:focus,\n    &:not(:disabled):not(.disabled):active {\n        color: #ffffff;\n        background-color: #077EE6;\n        border: 1px solid #077EE6;\n        box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n    }\n}\n\n.btn-lightblue {\n    font-weight: 400;\n    color: #ffffff;\n    text-align: center;\n    vertical-align: middle;\n    cursor: pointer;\n    user-select: none;\n    background-color: #36A1F5;\n    border: 1px solid #36A1F5;\n    padding: 0.5rem 0.75rem;\n    font-size: 14px;\n    line-height: 1.5;\n    border-radius: 0.2rem;\n    text-transform: uppercase;\n    transition: all 0.5s;\n    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n\n    &:hover,\n    &:active,\n    &:focus,\n    &:not(:disabled):not(.disabled):active:focus,\n    &:not(:disabled):not(.disabled).active:focus,\n    &:not(:disabled):not(.disabled):active {\n        color: #ffffff;\n        background-color: #2aa0fa;\n        border: 1px solid #2aa0fa;\n        box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n    }\n}\n.btn-lightblue-outline {\n    font-weight: 400;\n    color: #36A1F5;\n    text-align: center;\n    vertical-align: middle;\n    cursor: pointer;\n    user-select: none;\n    background-color: #F2F9FF;\n    border: 1px solid #36A1F5;\n    padding: 0.5rem 0.75rem;\n    font-size: 14px;\n    line-height: 1.5;\n    border-radius: 0.2rem;\n    text-transform: uppercase;\n    transition: all 0.5s;\n    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n\n    &:hover,\n    &:active,\n    &:focus,\n    &:not(:disabled):not(.disabled):active:focus,\n    &:not(:disabled):not(.disabled).active:focus,\n    &:not(:disabled):not(.disabled):active {\n        color: #ffffff;\n        background-color: #36A1F5;\n        border: 1px solid #36A1F5;\n        box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n    }\n}\n\n.btn-lightred {\n    font-weight: 400;\n    color: #CB3F3F;\n    text-align: center;\n    vertical-align: middle;\n    cursor: pointer;\n    user-select: none;\n    background-color: #FFEFEF;\n    border: 1px solid #FF004E;\n    padding: 0.5rem 0.75rem;\n    font-size: 14px;\n    line-height: 1.5;\n    border-radius: 0.2rem;\n    text-transform: uppercase;\n    transition: all 0.5s;\n    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n\n\n    &:hover,\n    &:active,\n    &:focus,\n    &:not(:disabled):not(.disabled):active:focus,\n    &:not(:disabled):not(.disabled).active:focus,\n    &:not(:disabled):not(.disabled):active {\n        color: #CB3F3F;\n        background-color: #fda3a3;\n        border: 1px solid #FF004E;\n        box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n    }\n}\n\n.btn-lightOrange {\n    font-weight: 400;\n    color: #feb019;\n    text-align: center;\n    vertical-align: middle;\n    cursor: pointer;\n    user-select: none;\n    background-color: #f8efde;\n    border: 1px solid #feb019;\n    padding: 0.5rem 0.75rem;\n    font-size: 14px;\n    line-height: 1.5;\n    border-radius: 0.2rem;\n    text-transform: uppercase;\n    transition: all 0.5s;\n    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n\n    &:hover,\n    &:active,\n    &:focus,\n    &:not(:disabled):not(.disabled):active:focus,\n    &:not(:disabled):not(.disabled).active:focus,\n    &:not(:disabled):not(.disabled):active {\n        color: #feb019;\n        background-color: #fce9c5;\n        border: 1px solid #feb019;\n        box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n    }\n}","@import '../../../../_config.scss';\n\n.complexity-nav {\n    position: relative;\n    background: #F39C37;\n\n    .header-top {\n        position: relative;\n        box-shadow: none;\n        z-index: 2;\n\n        .navbar-nav {\n            align-items: center;\n\n            .nav-link {\n                color: #ffffff;\n            }\n\n            .profile-img {\n                background: #ffffff2a;\n                border: 1px solid #ffc27b;\n                border-radius: 21px;\n\n                img {\n                    width: 35px;\n                    height: 35px;\n                }\n\n                .text {\n                    .profile-name {\n                        font-size: 14px;\n                        line-height: 6px;\n                    }\n                }\n            }\n        }\n\n        .search .search-bar {\n            color: #ffffff;\n            background: #e240567e;\n            box-shadow: none;\n        }\n\n        .student-notification i {\n            font-size: 1.5rem;\n        }\n    }\n\n    .header-bottom {\n        position: relative;\n        z-index: 1;\n\n        .title {\n            color: #ffffff;\n        }\n\n        .subtitle {\n            color: #ffffff;\n        }\n\n        .card {\n            border-radius: 10px;\n            background-color: #ffffff80;\n            border: 1px solid #FBE1C3;\n\n            img {\n                margin-top: -3rem;\n                margin-bottom: 10px;\n            }\n        }\n\n        .datePicker {\n            .calendar {\n                color: #ffffff;\n                position: absolute;\n                left: 15px;\n                top: 0;\n                font-size: 18px;\n                background: #ffffff3a;\n                padding: 10px;\n                border-radius: 4px;\n            }\n\n            .form-control {\n                padding-left: 40px;\n                border: 1px solid #FBE1C3;\n                background-color: #ffffff80;\n                color: #ffffff;\n\n                &::placeholder {\n                    color: #ffffff;\n                }\n            }\n\n            .rdtPicker {\n                right: 0;\n            }\n        }\n    }\n}\n\n.complexity-analysis {\n    .filter {\n        button {\n            padding: 0.45rem 1rem;\n            box-shadow: 0px 0px 10px #0000001A;\n        }\n    }\n\n    .exam-wise {\n        .card-header {\n            background: #EEEEEE;\n\n            h6.title {\n                color: #33333369;\n            }\n        }\n\n        .card-body .card-group .card {\n\n            .react-bootstrap-table,\n            .table {\n                border: none;\n                border-radius: 0;\n\n                thead {\n                    background: #EEEEEE;\n\n                    th {\n                        font-size: 13px;\n                        padding: 1rem 0.35rem;\n                        font-weight: 400;\n                        color: #707070;\n                    }\n                }\n\n                tbody tr td {\n                    font-size: 13px;\n                    padding: 0.95rem 0.35rem;\n\n                    &:nth-child(2) {\n                        color: #077EE6;\n                    }\n\n                    &:nth-child(3) {\n                        color: #00C596;\n                    }\n\n                    &:nth-child(4) {\n                        color: #FEAF55;\n                    }\n\n                    &:last-child {\n                        color: #F05D70;\n                    }\n                }\n            }\n        }\n    }\n\n    .complexity-subjects {\n        position: relative;\n        border-radius: 6px;\n\n        .table {\n            thead th {\n                border: 1px solid #dee2e6;\n\n                .accurency {\n                    background: #d8e1e980;\n                    border-radius: 5px;\n                    padding: 0.45rem 0.75rem;\n\n                    p {\n                        font-weight: 400;\n                    }\n                }\n            }\n        }\n    }\n\n    .complexity-question {\n        position: relative;\n\n        .react-bootstrap-table,\n        .table {\n            border: none !important;\n\n            thead {\n                background-color: #ffffff;\n            }\n\n            th,\n            td {\n                padding: 0.95rem 0.55rem;\n                outline: none;\n            }\n        }\n\n        .table {\n            thead {\n                border-top: 1px solid #dee2e6;\n                border-bottom: 1px solid #dee2e6;\n\n                th {\n                    border-right: 1px solid #dee2e6;\n\n                    &:nth-child(2n) {\n                        border-right: 1px solid #dee2e6;\n                    }\n\n                    &:last-child,\n                    &:nth-child(2),\n                    &:nth-child(4),\n                    &:nth-child(6),\n                    &:nth-child(8) {\n                        border-right: 0;\n                    }\n                }\n            }\n\n            tbody {\n                td {\n                    border-right: 1px solid #dee2e6;\n\n                    &:last-child,\n                    &:nth-child(2),\n                    &:nth-child(4),\n                    &:nth-child(6),\n                    &:nth-child(8) {\n                        font-weight: 600 !important;\n                        border-right: 0;\n                    }\n\n                    &:nth-child(3),\n                    &:nth-child(5),\n                    &:nth-child(7),\n                    &:nth-child(9) {\n                        font-weight: 400 !important;\n                        color: #077EE6;\n                    }\n                }\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
